import React, { useEffect } from "react"
import { Card, CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../../../_metronic/layout/index.js"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { stringFormatting, toMeter } from "../../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { linkWithCtrl } from "../../../../../helpers/Utils.js"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import {
  EmptyCard,
  // NoteView,
  TableSkeleton,
  TableView
} from "../../../../../../component/index.jsx"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import { ACTIVITY_TYPE_ENUM, DATE_TYPE_ENUM } from "../../../../../../constants/StringConstant.js"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../../constants/ImageConstants.js"

export function TabSendFinance({ data, changePage, history, general, isFilter }) {
  const subheader = useSubheader()
  const { t } = useTranslation()
  const { General } = useSelector((state) => state)

  useEffect(() => {
    subheader.setButton(undefined)
  }, [])

  const uiCode = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.area_name ?? "-"}</p>
        <span className="text-muted font-weight-bold d-block">
          {e?.land_area ? toMeter(e?.land_area) : "-"}
        </span>
      </>
    )
  }
  const uiFarmer = (e) => {
    //using data dummy before endpoint ready
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {e?.farmer_name ? e?.farmer_name : "-"}
        </p>
        <span className="text-muted font-weight-bold d-block">
          {e?.farmer_code ? e?.farmer_code : "-"}
        </span>
      </>
    )
  }
  const uiMitra = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.mitra_name ?? "-"}</p>
        <span className="text-muted font-weight-bold d-block">{e?.mitra_code ?? "-"}</span>
      </>
    )
  }
  const uiPlant = (e) => {
    //using data dummy before endpoint ready
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {e?.plant_type_name ? e?.plant_type_name : "-"}
        </p>
        <span className="text-muted font-weight-bold d-block">
          {e?.variety_name ? e?.variety_name : "-"}
        </span>
      </>
    )
  }
  const uiType = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {stringFormatting(e?.activity_name)}{" "}
          {e.is_seedling_package &&
            (e.activity_type_enum === ACTIVITY_TYPE_ENUM.PLANTING ||
              e.activity_type_enum === ACTIVITY_TYPE_ENUM.SEEDLING) &&
            `${t("label_seedling_package")}`}
        </p>
      </>
    )
  }

  const uiActivityDate = (e) => {
    const dateConvert = e?.activity_date
      ? timeStampToDate(e?.activity_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
      : "-"

    return (
      <>
        <p className="text-dark mb-1 font-size-lg">{dateConvert}</p>
      </>
    )
  }
  const uiCreatedDate = (e) => {
    const dateConvert = e?.submitted_date
      ? timeStampToDate(e?.submitted_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
      : "-"
    const TimeConvert = e?.submitted_date
      ? timeStampToDate(e?.submitted_date, DATE_TYPE_ENUM.ISO_TIME_STRAP)
      : "-"

    return (
      <>
        <p className="text-dark mb-1 font-size-lg">
          {dateConvert} <br /> {TimeConvert}
        </p>
      </>
    )
  }

  const linkDetail = (area_id, type, id, e) => {
    const url = RoutesConstants.AREA.DETAIL_ACTIVITY(area_id, type, id, e)
    if (e?.ctrlKey) {
      linkWithCtrl(url)
    } else {
      history.push(url)
    }
  }

  const columns = [
    {
      dataField: "plantingSeason.area.name",
      text: t("table_header_area_name"),
      sort: false,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      }
    },
    {
      dataField: "plantingSeason.area.farmer.name",
      text: t("table_header_farmer"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      }
    },
    {
      dataField: "plantingSeason.area.farmer.account.mitra.name",
      text: t("table_header_mitra"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      }
    },
    {
      dataField: "plant_name",
      text: t("table_header_planting_type"),
      sort: false,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiPlant
      }
    },
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiType
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },

    {
      dataField: "activityDate",
      text: t("table_header_activity_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiActivityDate
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCreatedDate
      }
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  function uiAction(e) {
    return (
      <>
        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
          <a
            onClick={() => {
              linkDetail(e?.area_id, e?.activity_type_enum.toLowerCase(), e?.id, e)
            }}
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DetailSvgIcon></DetailSvgIcon>
          </a>
        </OverlayTrigger>
      </>
    )
  }

  return (
    <>
      <Card className="card-shadowless">
        <CardBody>
          {/* this section is commented out due to the hotfix of the note view*/}
          {/* <NoteView title={t("label_note_view_activity_report_v2")} /> */}

          {General.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : data?.pageDataActivity?.length == 0 ? (
            <EmptyCard
              subtitle={isFilter && t("messages_response_empty_search_subtitle")}
              image={
                isFilter
                  ? ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
              }
              body={
                isFilter
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_empty_state", {
                      name: t("menu_aside_area_activity_report")
                    })
              }
            />
          ) : (
            ""
          )}

          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={data.pageDataActivity}
            currentPage={data.pageActivity.currentPage}
            currentElement={data.pageActivity.currentElement}
            totalCount={data.pageActivity.totalCount}
            loadingGetData={general.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            keyField={"id"}
          />
        </CardBody>
      </Card>
    </>
  )
}